"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyFeatures = void 0;
const CompanyFeatures = exports.CompanyFeatures = {
  AI: "ai",
  PAYMENT: "payment",
  ORDER: "order",
  EMAIL: "email",
  BARCODE: "barcode",
  CLOVER: "clover",
  INTERNAL_SKU: "internal_sku",
  BOTTLE_POS: "bottle_pos",
  INVENTORY: "inventory",
  TIERED_PRICING: "tiered_pricing",
  CUSTOMER_INVOICE_NUMBERING: "customer_invoice_numbering",
  MPOWER: "mpower",
  REPORTS: "reports",
  FINTECH: "fintech"
};